import React from 'react'
import { Modal, Button, Header } from 'semantic-ui-react'


const RestartDeliveryModal = ({ open, cancelCallback, continueCallback }) => {
    return (
        <Modal
            open={open}
            onClose={cancelCallback}
            size="small"
        >
            <Header icon='warning sign' color="red" content={"Bekräfta!"} />
            <Modal.Content>
                <h1>Makulera tidigare etiketter och börja om med utleveransen?</h1>
            </Modal.Content>
            <Modal.Actions>
                <Button secondary onClick={cancelCallback}>
                    NEJ
              </Button>
                <Button primary onClick={continueCallback}>
                    JA
              </Button>
            </Modal.Actions>
        </Modal>
    );
}


export default RestartDeliveryModal;










